<template>
  <v-layout column class="farm-shipment-card" v-if="shipment.id">
    <div class="text-xs-center font-weight-regular headline">Shipment Details</div>
    <div class="text-xs-center caption">ID: {{shipment.id}}</div>
    <div v-if="canAccess('SHIPMENT_EDIT') && !shipment.processed_at" class="edit-btn">
      <v-btn fab dark small color="primary" @click="handleEditShipment(shipment)" icon>
        <v-icon class="my-1">edit</v-icon>
      </v-btn>
    </div>

    <v-layout column class="px-3 py-2">
      <div class="label text-uppercase font-weight-bold px-3 py-2">From:</div>
      <div class="value font-weight-light px-3 py-2">{{getFarm(shipment.location).name}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Type of Meat:</div>
      <div class="value font-weight-light px-3 py-2">{{shipment.ingredient.name}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Butchering Date:</div>
      <div class="value font-weight-light px-3 py-2">{{formatDate(shipment.produced_at)}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Shipment Date:</div>
      <div class="value font-weight-light px-3 py-2">{{formatDate(shipment.shipped_at)}}</div>
    </v-layout>
    <div class="text-xs-center">Secured by Hyperledger Sawtooth</div>
    <a v-if="shipment.blockchain" :href="shipment.blockchain.state" class="text-xs-center hash">Hash:{{shipment.blockchain.address}}</a>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/date'
import { canAccess } from '@/utils/permissions'

export default {
  name: 'ShipmentCard',
  props: {
    shipment: Object
  },
  computed: {
    ...mapGetters({
      getFarm: 'getFarm'
    })
  },
  methods: {
    formatDate,
    canAccess,
    handleEditShipment (shipment) {
      this.$router.push({ name: 'shipments.edit', params: { id: shipment.id, shipment: shipment } })
    }
  }
}
</script>

<style lang="scss" scoped>
.farm-shipment-card{
  position: relative;
}
.infos-container{
  padding: 10px 25px;
}

.label{
  color: #858585;
  font-size: 12px;
}

.edit-btn{
  position: absolute;
  top: 0px;
  right: 0px;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #333333;
}

.value{
  background: white;
  font-size: 16px;
}
</style>
